import { TranRecordModel } from "./tran-record.model";

export class TreatGenModel {
    Trans: TranRecordModel[]
    intIndex: number
    intTotalIdx: number
    intClinicNo: number

    constructor(
        Trans: TranRecordModel[],
        intIndex: number,
        intTotalIdx: number,
        intClinicNo: number
    ) {
        this.Trans = Trans
        this.intIndex = intIndex
        this.intTotalIdx = intTotalIdx
        this.intClinicNo = intClinicNo
    }
}